
export class APIIntegration {
    static apiToken = ""   

    static setApiToken = (token: string) => {
      this.apiToken = token
    }

    /** @deprecated */
    static getErrorMessage = async (rawResponse: any) => {
      const errorText = await rawResponse.text();
      const errorMessage = `Error: ${rawResponse.status} - ${rawResponse.statusText}. \nDetails: ${errorText}`;
      return errorMessage
    }

}

class APIConfig {
    private env: string;
    private shouldUseLocalAPI: boolean;

    constructor() {
        // this.env = "PROD";
      this.env = process.env.REACT_APP_FRONT_ENV || this.inferEnvFromHostname();
      this.shouldUseLocalAPI = process.env.REACT_APP_USE_LOCAL_API === "YES" ? true : false
      console.log('APIConfig', this.env)
    }

    private inferEnvFromHostname() {
        if (typeof window !== "undefined" && window.location.hostname === "qa-auth.qontact.com.ar") {
            return "QA";
        }
        return "PROD";
    }
  
    // Local dev API, derived from the host serving the page so it also works from the
    // Android emulator's WebView (page on 10.0.2.2 -> API on 10.0.2.2:8080). In a
    // desktop browser this remains http://localhost:8080.
    private get localAPIBaseURL() {
        const hostname = typeof window !== "undefined" ? window.location.hostname : "localhost";
        return `http://${hostname}:8080`;
    }

    get baseURL() {
        if (this.shouldUseLocalAPI) {
            return this.localAPIBaseURL;
        }
        switch (this.env) {
            case 'PROD':
                return 'https://api.qeeptouch.com';
            case 'QA':
                return 'https://qa-api.qeeptouch.com';
            case 'LOCAL':
                return this.localAPIBaseURL;
            default:
                return 'https://api.qeeptouch.com';
      }
    }

    get waQRbaseUrl() {
      switch (this.env) {
        case 'PROD':
          return 'https://wa.me/5491157657668';
        case 'QA':
          return 'https://wa.me/5491151169134';
        case 'LOCAL':
          return 'https://wa.me/5491157657668';
        default:
          return 'https://wa.me/5491157657668';
      }
    }
}

export const apiConfig = new APIConfig();
